import { MeidenConnectCredentialsProvider } from "@meiden-connect/auth-frontend-sdk";
import type { ReactNode } from "react";
import { getWebConfig } from "../env";

interface Props {
  readonly children: ReactNode;
}

// MEIDEN CONNECT 認証 Shell。
// - authMode === "mock" のときは認証なしで通過させ、子要素のみを描画する（ローカル動作モード）
// - authMode === "required" のときは @meiden-connect/auth-frontend-sdk の Provider で包む
export function AuthShell({ children }: Props): ReactNode {
  const config = getWebConfig();

  if (config.authMode === "mock") {
    return children;
  }

  if (!config.authServiceOrigin || !config.serviceOrigin) {
    throw new Error(
      "authMode=required では authServiceOrigin と serviceOrigin の設定が必須です。/config/runtime.json を確認してください。"
    );
  }

  return (
    <MeidenConnectCredentialsProvider
      authServiceOrigin={config.authServiceOrigin}
      origin={config.serviceOrigin}
    >
      {children}
    </MeidenConnectCredentialsProvider>
  );
}
